import React from "react";
import { Skeleton } from "@mui/material";
import { Theme } from "../../../../providers/ThemeProvider";

const ServiceDetailsSkeleton = ({ theme }: { theme: Theme }) => {
  return (
    <div style={styles.serviceDetails}>
      <div style={styles.serviceDetailsHeader}>
        <Skeleton
          variant="rectangular"
          sx={{
            width: "200px",
            height: "32px",
            bgcolor: theme.colorTokens.N[30],
            borderRadius: "4px",
          }}
          animation="pulse"
        />
      </div>
      <div style={styles.serviceDetailsContent(theme)}>
        <Skeleton
          variant="rectangular"
          sx={{
            width: "120px",
            height: "120px",
            bgcolor: theme.colorTokens.N[30],
            borderRadius: "8px",
          }}
          animation="pulse"
        />
        <div style={styles.serviceDetailsContentWrapper(theme)}>
          <div style={styles.detailTitleContainer}>
            <Skeleton
              variant="rectangular"
              sx={{
                width: "150px",
                height: "28px",
                bgcolor: theme.colorTokens.N[30],
                borderRadius: "4px",
              }}
              animation="pulse"
            />
            <Skeleton
              variant="circular"
              sx={{
                width: "32px",
                height: "32px",
                bgcolor: theme.colorTokens.N[30],
              }}
              animation="pulse"
            />
          </div>
          <Skeleton
            variant="rectangular"
            sx={{
              width: "100%",
              height: "22px",
              bgcolor: theme.colorTokens.N[30],
              borderRadius: "4px",
              marginBottom: "8px",
            }}
            animation="pulse"
          />
          <div style={styles.detailElementsWrapper}>
            {/* Create 10 skeleton boxes for the detail elements */}
            {Array.from({ length: 10 }).map((_, index) => (
              <div key={index} style={styles.detailElementSkeleton}>
                <Skeleton
                  variant="rectangular"
                  sx={{
                    width: "80px",
                    height: "22px",
                    bgcolor: theme.colorTokens.N[30],
                    borderRadius: "4px",
                  }}
                  animation="pulse"
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    width: "120px",
                    height: "22px",
                    bgcolor: theme.colorTokens.N[30],
                    borderRadius: "4px",
                  }}
                  animation="pulse"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  serviceDetails: {
    display: "flex",
    flexDirection: "column" as "column",
    height: "100%",
  },
  serviceDetailsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "26px",
    paddingTop: "12px",
  },
  serviceDetailsContent: (theme: any) => ({
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "row" as "row",
    alignItems: "flex-start",
    gap: "16px",
    flex: 1,
    height: "100%",
  }),
  serviceDetailsContentWrapper: (theme: any) => ({
    paddingLeft: "16px",
    borderLeft: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    display: "flex",
    flexDirection: "column" as "column",
    flex: 1,
    height: "100%",
  }),
  detailTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "16px",
  },
  detailElementsWrapper: {
    paddingTop: "24px",
    display: "grid",
    gridTemplateColumns: "1fr 1.5fr",
    gridTemplateRows: "repeat(5, auto)",
    gap: "16px 32px",
    gridAutoFlow: "column",
  },
  detailElementSkeleton: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "4px",
    alignItems: "flex-start",
    width: "100%",
  },
};

export default ServiceDetailsSkeleton;
